import { ReportsState } from './states/reports.state';

export const reportsState = [
    ReportsState,
];